// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__Rah_1","inner":"Form_inner__2C6XU","range":"Form_range__vJDZZ","name":"Form_name__1immS","actions":"Form_actions__1C8C9"};